'use strict'
// Template version: 1.3.1
// see http://vuejs-templates.github.io/webpack for documentation.
const version = ['1.0.0 杨海波', '2.0.0 何嘉辉', '3.0.0 周熙孟']

// 1.1 本地运行测试环境
// const serverUrl = 'https://test.shendutv.com'
// const baseReq = '/api'

// 1.2 本地运行开发环境
// const serverUrl = 'https://wx.shendutv.com'
// const baseReq = '/api'

// 2. 线上测试环境
// const serverUrl = 'https://test.shendutv.com'
// const baseReq = ''

// 3. 线上正式环境
const serverUrl = 'https://wx.shendutv.com'
const baseReq = ''

const simonConfig = {
  version,
  serverUrl,
  baseReq
}

const path = require('path')
module.exports = {
  simonConfig,
  dev: {
    // Paths
    assetsSubDirectory: 'static',
    assetsPublicPath: '/',
    // 这里的proxyTable是虚设的，都没有调用
    proxyTable: {
      '/api': {  //使用"/api"来代替"http://test.shendutv.com"
        target: simonConfig.serverUrl, //需要代替的源地址
        // target: 'https://test.shendutv.com', //需要代替的源地址
        // target: 'https://wx.shendutv.com', //需要代替的源地址

        changeOrigin: true, // 是否允许跨域
        pathRewrite: {
          '^/api': simonConfig.serverUrl
          // '^/api': 'https://test.shendutv.com'
          // '^/api': 'https://wx.shendutv.com' // 具有‘/api’字符串的替代成这个,一般不做更改
          }
      }
    },
    // Various Dev Server settings
    // host: '0.0.0.0', // can be overwritten by process.env.HOST // 也可以根据ipconfig里的ip4来定
    host: '0.0.0.0', // 公司的ip
    port: 8086, // can be overwritten by process.env.PORT, if port is in use, a free one will be determined
    autoOpenBrowser: false,
    errorOverlay: true,
    notifyOnErrors: true,
    poll: false, // https://webpack.js.org/configuration/dev-server/#devserver-watchoptions-

    // Use Eslint Loader?
    // If true, your code will be linted during bundling and
    // linting errors and warnings will be shown in the console.
    useEslint: false,
    // If true, eslint errors and warnings will also be shown in the error overlay
    // in the browser.
    showEslintErrorsInOverlay: false,

    /**
     * Source Maps
     */

    // https://webpack.js.org/configuration/devtool/#development
    devtool: 'cheap-module-eval-source-map',

    // If you have problems debugging vue-files in devtools,
    // set this to false - it *may* help
    // https://vue-loader.vuejs.org/en/options.html#cachebusting
    cacheBusting: true,

    cssSourceMap: true
  },

  build: {
    // Template for index.html
    index: path.resolve(__dirname, '../dist/index.html'),

    // Paths
    assetsRoot: path.resolve(__dirname, '../dist'),
    assetsSubDirectory: 'static',
    assetsPublicPath: '/',

    /**
     * Source Maps
     */

    productionSourceMap: true,
    // https://webpack.js.org/configuration/devtool/#production
    devtool: '#source-map',

    // Gzip off by default as many popular static hosts such as
    // Surge or Netlify already gzip all static assets for you.
    // Before setting to `true`, make sure to:
    // npm install --save-dev compression-webpack-plugin
    productionGzip: false,
    productionGzipExtensions: ['js', 'css'],

    // Run the build command with an extra argument to
    // View the bundle analyzer report after build finishes:
    // `npm run build --report`
    // Set to `true` or `false` to always turn it on or off
    bundleAnalyzerReport: process.env.npm_config_report
  }
}



//////////////////
// WEBPACK FOOTER
// ./config/index.js
// module id = FhoZ
// module chunks = 17